
import * as _ from 'lodash'

const allRegions:string[] = [
    // test
    'cn-qingyangtest-1', 'cn-qingdaodev-1',

    // online
    'cn-beijing-6', 'cn-shanghai-2',
    'cn-hongkong-2',
    'cn-beijing-1-new', // 改造机房
    'ap-singapore-1', 'ap-singapore-2',
    'cn-guangzhou-1', 'eu-east-1',
    'cn-taipei-1', 'cn-qingdao-1',
    'cn-beijing-fin', 'cn-shanghai-fin',
    'cn-north-1-gov',
    'cn-central-1'
]

const getAllRegions = () => {
    return _.cloneDeep(allRegions);
}

const blackList = (banRegions:string[]) => {
    return _.filter(allRegions, r => _.includes(banRegions, r));
}





const available:any = {
    vpc: ['cn-beijing-6', 'cn-shanghai-2', 'cn-qingyangtest-1',
        'cn-hongkong-2', 'cn-beijing-5', 'cn-beijing-1-new', 'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1', 'cn-wuhan-1', 'eu-east-1', 'cn-taipei-1', 'cn-qingdao-1', 'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov', 'cn-qingdaodev-1',
        'cn-central-1',
        'cn-southwest-1'
    ],
    vpcIpv6: ['cn-beijing-6', 'cn-qingyangtest-1', 'cn-shanghai-2', 'cn-guangzhou-1', 'cn-qingdaodev-1'
        // , 'cn-guangzhou-1'
        // 'cn-north-1-gov'
    ],
    vpcNoNat: ['cn-guangzhou-1', 'eu-east-1', 'cn-taipei-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin', "ap-singapore-1", 'ap-singapore-2',
        'cn-north-1-gov', 'cn-qingdaodev-1',
        'cn-central-1',
        'cn-southwest-1'
    ],
    acl: ['cn-beijing-6', 'cn-shanghai-2', 'cn-qingyangtest-1',
        'cn-hongkong-2', 'cn-beijing-5', 'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1', 'cn-wuhan-1', 'eu-east-1', 'cn-taipei-1', 'cn-qingdao-1', 'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov', 'cn-qingdaodev-1',
        'cn-central-1',
        'cn-southwest-1'
    ],
    bws: [
        'cn-beijing-6', 'cn-shanghai-2',
        'cn-beijing-1', 'cn-shanghai-1',
        'cn-qingyangtest-1', 'cn-shanghai-7',
        'cn-hongkong-2', 'cn-beijing-1-new',
        'cn-guangzhou-1',
        'cn-wuhan-1',
        'ap-singapore-1', 'ap-singapore-2', 'cn-taipei-1',
        'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov', 'cn-qingdaodev-1',
        'cn-central-1',
        'cn-southwest-1'
    ],

    peer: ['cn-beijing-6', 'cn-shanghai-2', 'cn-qingyangtest-1',
        'cn-hongkong-2', 'cn-beijing-5', 'cn-beijing-1-new', 'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1', 'cn-wuhan-1', 'eu-east-1', 'cn-taipei-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov', 'cn-qingdaodev-1'
    ],


    //SLB新建监听器 除了这些机房显示 HTTP TCP
    kcm: [
        'cn-beijing-6', 'cn-shanghai-2',
        'cn-shanghai-1',
        'cn-beijing-3',
        'cn-qingyangtest-1',
        'cn-shanghai-7',
        'cn-hongkong-2',
        'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1',
        'cn-wuhan-1', 'eu-east-1', 'cn-taipei-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov', 'cn-qingdaodev-1',
        'cn-central-1'
        // 'cn-beijing-1'
    ],

    dc: ['eu-east-1', 'cn-beijing-6', 'cn-qingyangtest-1', 'cn-shanghai-2', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-wuhan-1', 'cn-qingdaodev-1'],

    dcBfd: [
        'cn-qingyangtest-1',
        'cn-shanghai-2',
        'cn-beijing-6',
        'cn-guangzhou-1'
    ],

    vpn: ['cn-beijing-6', 'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-shanghai-2', 'cn-qingyangtest-1', 'cn-guangzhou-1', 'cn-wuhan-1',
        'cn-north-1-gov', 'cn-qingdaodev-1', 'cn-taipei-1', 'ap-singapore-1', 'ap-singapore-2',
        'eu-east-1',
    ],


    slbApply: ['cn-beijing-6', 'cn-qingyangtest-1', 'cn-shanghai-2', 'cn-qingdaodev-1'],

    slbNoCreate: ['cn-beijing-1-new'],
    slbNoUnbind: ['cn-beijing-1-new'],
    slbNoBind: ['cn-beijing-1-new'],
    slbNoOpen: ['cn-beijing-1-new', 'cn-beijing-1'],
    slbNoClose: ['cn-beijing-1-new', 'cn-beijing-1'],
    slbNoDelete: ['cn-beijing-1-new', 'cn-beijing-1'],

    slbIpV6: ['cn-qingyangtest-1', 'cn-beijing-6', 'cn-guangzhou-1', 'cn-shanghai-2', 'cn-qingdaodev-1'],

    bwsNoCreate: ['cn-beijing-1-new', 'cn-beijing-1', 'eu-east-1'],
    bwsNoDelete: ['cn-beijing-1-new', 'cn-beijing-1'],
    bwsNoUpdate: ['cn-beijing-1-new', 'cn-beijing-1'],
    bwsNoEipEnter: ['cn-beijing-1-new', 'cn-beijing-1'],
    bwsNoEipLeave: ['cn-beijing-1-new', 'cn-beijing-1'],


    eipNoCreate: ['cn-beijing-3', 'cn-beijing-1', 'cn-shanghai-1', 'cn-hongkong-1', 'cn-beijing-5', 'cn-shanghai-7', 'cn-beijing-1-new'],

    eipNoDelete: ['cn-beijing-1'],
    // eipNoDelete: ['cn-beijing-1-new', 'cn-beijing-1'],
    eipNoRenew: ['cn-beijing-1-new', 'cn-beijing-1'],
    eipNoUnbind: [],
    eipNoBind: [],

    eipNoUpdate: ['cn-beijing-1-new', 'cn-beijing-1'],

    canCreateDefaultVpc: ['cn-beijing-1-new'],

    tunnelNoCreate: ['cn-beijing-1-new'],

    //已写业务里
    //SLB HTTPS协议的监听器: 删除 修改 创建   basic vpc
    //证书 创建删除 亦庄屏蔽   basic  vpc
    //子网不允许更改网络   vpc
    //亦庄不允许新建公网NAT   vpc
    //亦庄不允许新建跨机房peering   vpc

    lbAcl: ['cn-qingyangtest-1', 'cn-shanghai-2', 'cn-beijing-6',
        // 'cn-hongkong-2',
        'cn-guangzhou-1', 'cn-taipei-1',
        'ap-singapore-1', 'ap-singapore-2',
        'eu-east-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin', 'cn-qingdaodev-1',
        'cn-central-1',
        'cn-southwest-1'
    ],

    // 3.4.3
    vlanBGP: ['cn-qingyangtest-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-guangzhou-1',
        'cn-beijing-6', 'eu-east-1', 'cn-taipei-1', 'cn-shanghai-2', 'cn-qingdaodev-1'],

    lbSupportHttpVersion: ['cn-qingyangtest-1', 'cn-beijing-6', 'eu-east-1',
        'cn-beijing-fin', 'cn-shanghai-fin', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-hongkong-2',
        'cn-qingdao-1', 'cn-taipei-1', 'cn-qingdaodev-1'
    ],
    // 3.4.4
    lbSupportTLS: ['cn-qingyangtest-1', 'cn-beijing-6',
        'cn-beijing-fin', 'cn-shanghai-fin', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-hongkong-2',
        'cn-qingdao-1', 'cn-taipei-1', 'cn-qingdaodev-1'
    ],
    // slb ks3 bucket log
    slbKs3BucketLog: ['cn-beijing-6', 'cn-qingyangtest-1', 'cn-shanghai-2', 'cn-qingdaodev-1'],
    // 子网预留
    subnetReserve: ['cn-qingyangtest-1', 'cn-shanghai-2', 'cn-beijing-6', 'eu-east-1', 'cn-qingdaodev-1'],
    // 3.4.7
    lbSupportHttp2: ['cn-beijing-6', 'cn-qingyangtest-1', 'eu-east-1', 'cn-qingdaodev-1'],
    // 3.5.0
    // vpcSupportIpv6: ["cn-shanghai-2", 'cn-qingyangtest-1', 'cn-qingdaodev-1'],
    vpcSupportIpv6: ["cn-shanghai-2", 'cn-qingyangtest-1', 'cn-beijing-6', 'cn-qingdaodev-1'
        , 'cn-guangzhou-1', 'cn-beijing-fin'
        // 'cn-north-1-gov'
    ],
    httpLbRedirectHttps: ['cn-shanghai-2', 'cn-qingyangtest-1', 'cn-beijing-6', 'eu-east-1',
        'cn-beijing-fin', 'cn-shanghai-fin', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-hongkong-2',
        'cn-qingdao-1', 'cn-taipei-1', 'cn-qingdaodev-1'
    ],
    // 3.5.1 dcRoute and can publish to bgp
    bgpRoute: ['cn-shanghai-2', 'cn-qingyangtest-1', 'cn-qingdaodev-1',
        'cn-beijing-6',
        "cn-hongkong-2", "eu-east-1", "ap-singapore-1", 'ap-singapore-2', "cn-guangzhou-1",
        "cn-taipei-1", "cn-qingdao-1", "cn-shanghai-fin", "cn-beijing-fin",
        'cn-north-1-gov',
        // "cn-hongkong-2", "eu-east-1", "ap-singapore-1", 'ap-singapore-2', "cn-guangzhou-1",
        // "cn-taipei-1", "cn-qingdao-1", "cn-shanghai-fin", "cn-beijing-fin",
        // 'cn-north-1-gov',
    ],
    dcRoute: ["cn-beijing-6", "cn-shanghai-2", "cn-hongkong-2", "eu-east-1", "ap-singapore-1", 'ap-singapore-2', "cn-guangzhou-1", "cn-taipei-1", "cn-qingdao-1", "cn-shanghai-fin", "cn-beijing-fin"
        , 'cn-qingdaodev-1'],
    // 新建路由，主机路由支持0.0.0.0
    hostRouteSupportZero: ['eu-east-1', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-hongkong-2', 'cn-taipei-1'
        , 'cn-qingdaodev-1'],
    pdns: ['cn-qingyangtest-1', 'cn-beijing-6'],
    // 弹性网卡
    evif: [
        'cn-qingyangtest-1', 'cn-beijing-6', 'cn-shanghai-2',
        'eu-east-1',
        'cn-beijing-fin', 'cn-shanghai-fin', 'cn-guangzhou-1', 'ap-singapore-1', 'ap-singapore-2', 'cn-hongkong-2',
        'cn-qingdao-1', 'cn-taipei-1', 'cn-qingdaodev-1',
        'cn-north-1-gov',
        'cn-central-1'
    ],
    slbAclSupportIPv6: [
        'cn-qingyangtest-1', 'cn-qingdaodev-1',
        'cn-beijing-6',
        'cn-guangzhou-1'
        // 'cn-guangzhou-1'
    ],
    reserveSubnetSupportIPv6: [
        'cn-qingyangtest-1', 'cn-qingdaodev-1',
        'cn-beijing-6',
        'cn-guangzhou-1'
    ],

    kciBindSupport: [
        'cn-qingyangtest-1', 'cn-beijing-6',
        'cn-guangzhou-1',
        // 'cn-guangzhou-1'
    ],
    vpcSupportRouteTable: ["cn-shanghai-2", "cn-qingyangtest-1", 'cn-qingdaodev-1'],
    vpcSupportNatLimitRate: ["cn-guangzhou-1"],
    sgTag: ['cn-qingyangtest-1', 'cn-qingdaodev-1',
        "cn-beijing-6", "cn-shanghai-2",
        "cn-hongkong-2", "eu-east-1", "ap-singapore-1", 'ap-singapore-2', "cn-guangzhou-1",
        "cn-taipei-1", "cn-qingdao-1", "cn-shanghai-fin", "cn-beijing-fin",
        'cn-north-1-gov',"cn-north-vip1", "cn-southwest-1", "cn-central-1", "cn-northwest-3",
        "cn-northwest-2", "cn-northwest-1"
    ],
    epcSg: [
        'cn-qingyangtest-1',
        "cn-beijing-6", "cn-shanghai-2",
        "cn-hongkong-2", "cn-shanghai-fin", "cn-taipei-1",
        'cn-central-1', "cn-guangzhou-1", "ap-singapore-1", 'ap-singapore-2',
        "eu-east-1",
        'cn-southwest-1'
    ],
    // 安全组deny-云主机 白名单
    sgSupportDeny: [
        'cn-qingyangtest-1', 'cn-qingdaodev-1',
        'cn-guangzhou-1',
        "cn-beijing-6", "cn-shanghai-2", "cn-taipei-1",
        "cn-hongkong-2", "ap-singapore-1", 'eu-east-1', 'cn-beijing-fin', 'cn-shanghai-fin', 'cn-north-vip1', 'cn-northwest-3', 'cn-northwest-1'
    ],
    // sgSupportNewUi: [
    //     'cn-qingyangtest-1',
    //     "cn-beijing-6", "cn-shanghai-2"
    // ],
    securityGroupsSearchSortExport: [
        // test
        'cn-qingyangtest-1', 'cn-qingdaodev-1',
    
        // online
        'cn-beijing-6', 'cn-shanghai-2',
        'cn-hongkong-2',
        'cn-beijing-1-new', // 改造机房
        'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1', 'eu-east-1',
        'cn-taipei-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov','cn-northwest-1',
        'cn-central-1', 'cn-northwest-3',
        "cn-southwest-1", 'cn-qingyangtest-1',
        'cn-north-vip1',

    ],
    exportRules:[
        // test
        'cn-qingyangtest-1', 'cn-qingdaodev-1',
    
        // online
        'cn-beijing-6', 'cn-shanghai-2',
        'cn-hongkong-2',
        'cn-beijing-1-new', // 改造机房
        'ap-singapore-1', 'ap-singapore-2',
        'cn-guangzhou-1', 'eu-east-1',
        'cn-taipei-1', 'cn-qingdao-1',
        'cn-beijing-fin', 'cn-shanghai-fin',
        'cn-north-1-gov',
    ],
    vpcTrust2:['cn-northwest-3','cn-shanghai-2','cn-qingyangtest-1']
};

function isVpc(code:any) {
    return available.vpc.indexOf(code) != -1;
}

function check(product:any, region:any) {
    let list = available[product];
    if (!list) {
        return true;
    }
    return list.indexOf(region) != -1;
}

export default {
    check,
    isVpc
}
